import { useMemo } from "react";

export default function Starfield({ count = 40, className = "" }) {
  const stars = useMemo(() => Array.from({ length: count }, (_, i) => ({
    left: `${(i * 37.7) % 100}%`,
    top: `${(i * 53.3) % 100}%`,
    size: 1 + ((i * 7) % 3),
    delay: `${(i % 10) * 0.4}s`,
    duration: `${2.5 + (i % 5)}s`,
  })), [count]);

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {stars.map((s, i) => (
        <span
          key={i}
          className="absolute rounded-full bg-cloud animate-twinkle"
          style={{ left: s.left, top: s.top, width: s.size, height: s.size, animationDelay: s.delay, animationDuration: s.duration }}
        />
      ))}
    </div>
  );
}
